import { render, staticRenderFns } from "./HomeBackground.vue?vue&type=template&id=70761afe&scoped=true"
import script from "./HomeBackground.vue?vue&type=script&lang=js"
export * from "./HomeBackground.vue?vue&type=script&lang=js"
import style0 from "./HomeBackground.vue?vue&type=style&index=0&id=70761afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70761afe",
  null
  
)

export default component.exports